'use client';

import React, { useCallback } from 'react';
import { Button, DropdownMenu, Flex, Text } from '@radix-ui/themes';

export interface DropdownProps {
  options?: IDropdownOptions;
  onChange: (key: string, value: string) => void;
  value?: string | number;
  className?: string;
}

export interface DropdownItem {
  key: string;
  value: string;
}

export interface IDropdownOptions {
  placeholder: string;
  items: DropdownItem[];
  id?: string;
  type?: 'form';
}

export const Dropdown: React.FC<DropdownProps> = ({
  value,
  options,
  onChange,
  className,
}) => {
  const onSelectOption = useCallback(
    (key: string, value: string) => {
      onChange(key, value);
    },
    [onChange]
  );

  return (
    <Flex className={className} align="start">
      <DropdownMenu.Root>
        <DropdownMenu.Trigger>
          {options?.type === 'form' ? (
            <Button
              variant="surface"
              size="4"
              className="w-full justify-between p-4 text-sm"
              color="gray"
            >
              <Text align="left" className="text-white">
                {value || options.placeholder}{' '}
              </Text>
              <DropdownMenu.TriggerIcon />
            </Button>
          ) : (
            <Button
              variant="soft"
              className="text-white bg-[#012A38] font-semibold rounded-lg"
            >
              {value || options?.placeholder}
              <DropdownMenu.TriggerIcon />
            </Button>
          )}
        </DropdownMenu.Trigger>
        <DropdownMenu.Content className="bg-gradient-to-b from-[rgba(255,255,255,0.9)] to-[rgba(255,255,255,0)] via-[hsl(185,42%,80%)] rounded-lg shadow-lg shadow-gray-500 max-h-[250px] overflow-y-auto">
          {options?.items.map((item, index) => (
            <div key={item.key}>
              <DropdownMenu.Item
                onSelect={() => onSelectOption(item.key, item.value)}
                className="font-semibold text-sm text-[#4F6169] hover:bg-transparent rounded-lg hover:shadow-md hover:shadow-gray-400 transition duration-200 hover:cursor-pointer active:scale-95"
              >
                {item.value}
              </DropdownMenu.Item>
              {index < options?.items.length - 1 && (
                <hr className="border-t border-black my-1" />
              )}
            </div>
          ))}
        </DropdownMenu.Content>
      </DropdownMenu.Root>
    </Flex>
  );
};
